<template>
	<div class="nav">
		<a class="logo" href="#/home"><img src="@/assets/logo.png"></a>
		<div class="items">
			<div v-if='checkPermission(item.RoleCode)' v-for='(item,index) in leftMenus' :key='item.Code' class="item" :class='{active:activeIndex == index}' @mouseenter='hoverActive=item.Code' @mouseleave="hoverActive=-1">
				<a class="top-link"  @click='href(item)'><span class="zh">{{item.Label}}</span><br><span class="en">{{item.LabelEN}}</span></a>
				<div v-if='hoverActive==item.Code && item.Childs.length'  class="dropmenus" :class='{"help-center":item.Code =="DT_WS_HelpCenterCatalog"|| item.Code == "DT_WS_DownloadCatalog","download-center":item.Code == "DT_WS_DownloadCatalog"}'>
					<div class="content" v-if='item.Code !="WSFT_Product"'>
						<div v-if='item.Description' class="desc" v-html='item.Description'></div>
						<div class="menu-box" :class='{"help":item.Code =="DT_WS_HelpCenterCatalog" || item.Code == "DT_WS_DownloadCatalog","download-menu":item.Code == "DT_WS_DownloadCatalog"}'>
							<div class="sub-menu" v-for='(item1,index) in item.Childs' :key='item1.Code'>
								<a class="menu title" @click='href(item1)'  v-if='checkPermission(item1.RoleCode)' :key="item1.Code">
									{{item1.Label}}
									<br v-if='item.Code == "DT_WS_DownloadCatalog"' />
									<template v-else>&nbsp;&nbsp;</template>
									{{item1.LabelEN}}
								</a>
								<div class="desc" v-if='item1.Description' v-html='item1.Description'></div>
								<div class="sub2-menu" v-if='item.Code != "DT_WS_DownloadCatalog"'>
									<a @click='href(item2)'  v-for='(item2,index2) in item1.Childs' v-if='checkPermission(item2.RoleCode)' class="menu" :key="item2.Code">{{item2.Label}}&nbsp;&nbsp;{{item2.LabelEN}}</a>
								</div>
							</div>
						</div>
					</div>
					<div class="content" v-else>
						<div v-if='item.Description' class="desc" v-html='item.Description'></div>
						<div class="p-menus">
							<div class='p-menu' v-for='pmenu in productMenuTree' v-if='pmenu.Code != "All"' :key='pmenu.Code' @click='href(pmenu)'>
								<div class='p-menu-content' @mouseenter='mouseenter($event,pmenu)'>
									<div>{{pmenu.Name}}&nbsp;&nbsp;{{pmenu.NameEN}}</div>
									<div class='p-sub-menus-box' v-if='pmenu.Childs.length' :style='tipStyle'>
										<div class='p-sub-menus'>
											<div class="triangle" :style='triangleStyle'></div>
											<div class="p-sub-menu" v-for='psubmenu in pmenu.Childs' @click.stop='href(psubmenu)' :key='psubmenu.Code'>
												{{psubmenu.Name}}&nbsp;&nbsp;{{psubmenu.NameEN}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="search">
			<Input v-model='keys' size='large' class='input' placeholder='请输入您要搜索的内容' @keyup.enter.native='search'>
				<Button @click='search' type='text' class='search-btn' slot="suffix" ><Icon type="ios-search" color='#BD8BCA' /></Button>
			</Input>
		</div>
		<div class="icon-btns">
			<a @click='href(item)' class="item" v-for='(item,index) in rightMenus' :class='{active:activeIndex - leftMenus.length == index}' @mouseenter='hoverActive=item.Code' @mouseleave="hoverActive=-1" :key='item.Code'>
			<Badge :count="cartCount" type="primary"  :offset='[0,-15]' v-if='item.Code=="WSFT_Shopcart"'>
       			<a  class="demo-badge"></a>
    		</Badge>
				<div>
					<img :src="item.Icon" alt="" class="icon">
					<span class="title"><span class="zh">{{item.Label}}</span><br><span class="en">{{item.LabelEN}}</span>	
					</span>
				</div>
				<div class="guide" v-if='hoverActive == "WSFT_Guide" && item.Code == "WSFT_Guide"' @click.stop>
					<a :href="item.Href" v-for='item in item.Childs' :key='item.Code'>{{item.Label}}<br>{{item.LabelEN}}</a>
				</div>
				<div class="myo-hover" v-if='hoverActive == "WSFT_Myo" && item.Code == "WSFT_Myo"' @click.stop>
					<div class="login-info" v-if='isLogin'>
						<!-- <div class="head-img">
							<img :src="userInfo.value.head_image_url">
						</div> -->
							<div class="info">
								<div class="user"><p class="name">{{userInfo.value.binding.name}}</p><p class="vipno">({{userInfo.value.binding.register.vip_no}})</p></div>
								<div @click='logout' class="button-primary logout">退出登录</div>
							</div>
							<div class="selectOrder" @click="goOrder">
								<a>查询我的订单<span>（My Order）</span></a>
							</div>
					</div>
					
					<div class="reg-login" v-else>
						<p class="welcome">欢迎来到dōTERRA</p>
						<div class="button-primary btn reg" @click='goReg'><span>创建账户(Account Registration)</span></div>
						<div class="button btn login" @click='goLogin(false)'><span>登录(Log-in MyŌ)</span></div>
					</div>
				</div>
				<div class="contact" v-if='hoverActive == "WSFT_Abount" && item.Code == "WSFT_Abount"' @click.stop>
					<a :href="item.Href" v-for='item in item.Childs' :key='item.Code'>{{item.Label}}&nbsp;&nbsp;{{item.LabelEN}}</a>
				</div>
				<Cart :showCart='hoverActive == "WSFT_Shopcart" && item.Code == "WSFT_Shopcart"' @showCustomer='showCustomer' @showPromoCode='showPromoCode' ></Cart>
			</a>
		</div>
		<newCustomer :value='newValue' @close='close'  @login='goLogin' />
		<PromoCode :products='PromoModel' :show='PromoModelShow' :opType='PromoModelType' @showPromoCode='showPromoCode'></PromoCode>
		<Modal v-model="showModal" footer-hide>
        	<div class="modal-content">
        		<div v-html='modalContent.Content'></div>
        	</div>
	    </Modal>
	    <Modal v-model="showFeedbackModal" title='留言反馈' :styles='{width:"640px",top:"0"}'  footer-hide>
        	<Feedback v-if='showFeedbackModal'/>
	    </Modal>
	</div>
</template>

<script>
	import mixin from './mixin.js';
	export default {
		mixins:[mixin],
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	@import '@/style/common';
	.nav {
		z-index:9999;
		width: 100vw;
		background-color: white;
		// border-bottom: 1px solid rgba(238, 238, 238, 1);
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, .2);
		height: 1rem;
		display: flex;
		align-items: center;
		position: fixed;
		.logo {
			margin: 0 0.3rem;
			height: 0.2rem;
			width: auto;
			img {
				height: 0.2rem;
			}
		}
		.items {
			display: flex;
			.item {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 0 0.2rem;
				height: 1rem;
				@include fontSize($font-size-16);
				cursor: pointer;
				color: #515a6e;
				position: relative;
				.top-link {
					text-align: center;
					.en {
						@include fontSize($font-size-15);
					}
				}
				a:hover {
					color: $theme-color;
				}
				
				&:hover:after {
					left: 0;
					content: '';
					display: block;
					width: 100%;
					position: absolute;
					bottom: 0;
					border-bottom: 2px solid $theme-color;
					animation: stretch-width .2s ease-in-out
				}
			}
			.active:after {
				content: '';
				display: block;
				left: 0;
				width: 100%;
				position: absolute;
				bottom: 0;
				border-bottom: 2px solid $theme-color;
				animation: stretch-width .2s ease-in-out // border-bottom: 2px solid $theme-color;
			}
		}
		.search {
			flex: 1;
			.input {
				margin: auto;
				// max-width: 600px;
				display: block;
			}
			.search-btn {
				outline: none;
				&:hover,&:focus {
					outline: none;
					background-color: transparent;
					box-shadow:none;
				}
			}
		}
		.icon-btns {
			position: relative;
			display: flex;
			right: 0;
			justify-self: flex-end;
			.active:after {
				content: '';
				display: block;
				width: 100%;
				position: absolute;
				left: 0;
				bottom: 0;
				border-bottom: 2px solid $theme-color;
				animation: stretch-width .2s ease-in-out // border-bottom: 2px solid $theme-color;
			}
			.item {
				// flex:1;
				margin: 0 0.2rem;
				display: flex;
				text-align: center;
				flex-direction: column;
				cursor: pointer;
				height: 1rem;
				align-items: center;
				justify-content: center;
				position: relative;
				color:#333;
				@include fontSize($font-size-16);
				.en {
					@include fontSize($font-size-15);
				}
				&:hover:after {
					left: 0;
					position: absolute;
					bottom: 0;
					content: '';
					display: block;
					width: 100%;
					border-bottom: 2px solid $theme-color;
					animation: stretch-width .2s ease-in-out
				}
				.icon {
					display: block;
					margin: auto;
					width: 0.2rem;
					margin-bottom: 5px;
				}
			}
		}
	}
	.dropmenus {
		z-index: 999;
		position: fixed;
		top: 1rem;
		width: 100vw;
		left: 0;
		max-height:min(600px,calc(100vh - 1rem - 5px));
		background-color: white;
		overflow-y: scroll;
		padding-top: 4px;
		animation: stretch-height .25s ease-in-out;
		.content {
			margin:20px 5.21vw 40px;
			display:flex;
		}
		.p-menus {
			flex:1;
			margin-left: 20px;
			display:flex;
			flex-wrap: wrap;
			.p-menu {
				width:50%;
				margin-top: 20px;
				position:relative;
				display:flex;
				.p-sub-menus-box {
					display:none;
					position:fixed;
					max-width: 675px;
					z-index:9999;
				}
				.p-menu-content:hover .p-sub-menus-box {
					display:block;
					.p-sub-menus {
						box-shadow: 2px 3px 10px rgba(0,0,0,0.1);
						display:flex;
						flex-wrap: wrap;
						// gap:15px;
						padding:10px 0;
						@include flex-gap(15px,'row wrap');
						background-color:#EFEFEF;
						// justify-content: space-between;
						border-radius: 10px;
						margin-top: 20px;
						.triangle {
							border-color: transparent;
							border-bottom: #EFEFEF;
							border-width: 25px; 
							border-style: solid;
							height:0;
							width:0;
							position:fixed;
							top: -20px;
							left:50px;
						}
						.p-sub-menu {
							width:150px;
							background-color:#C9C9C9;
							text-align:center;
							// margin-bottom: 15px;
							padding:5px;
							border-radius: 10px;
							transition:all 0.3s;
							overflow:hidden;
							white-space: nowrap;
							text-overflow:ellipsis;
							&:hover {
								color:white;
								background-color:$theme-color
							}
						}
					}
				}
				 
			}
		}
		.desc {
			margin: 10px 0;
		}
		.menu-box {
			flex:1;
			display: flex;
			justify-content: space-around;
			.sub-menu {
				.title {
					color: #333;
					font-weight: bold;
					@include fontSize($font-size-20);
				}
				.sub2-menu {
					flex-direction: column;
					display: flex;
				}
			}
			.menu {
				margin: 10px 0;
				&:hover {
				}
			}
		}
		.products {
			flex-direction: column;
			margin-left: 40px;
			.sub-menu {
				.title {
					display: block;
					font-weight: normal;
					@include fontSize($font-size-16);
					margin-bottom: 5px;
				}
			}
		}
		box-shadow: 0 3px 5px 1px rgba(0, 0, 0, .2);
	}
	.help-center {
		overflow: hidden;
		position: absolute;
		width: 3rem;
		left: - 0.9rem;
		margin: 0;
		padding: 0;
		.content {
			margin: 0;
			overflow: hidden;
		}
		.help {
			padding: 10px 0;
			flex-direction: column;
			align-items: center;
			margin-left: 0;
			.sub-menu {
				.title {
					display: block;
					font-weight: normal;
					@include fontSize($font-size-16);
					margin-bottom: 5px;
				}
			}
		}
		
	}
	.download-center {
		overflow: scroll;
		.download-menu {
			.sub-menu {
				.title {
					text-align:center;
				}
			}
		}
	}
	.myo-hover {
		z-index: 999;
		position: absolute;
		cursor: auto;
		top: 1rem;
		left: -13vw;
		background-color: white;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, .2);
		.reg-login {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 23.44vw;
			height: 18.23vw;
			position: relative;
		}
		.welcome {
			color: black;
			font-weight: bold;
			@include fontSize($font-size-23);
			margin-top: 2.08vw;
		}
		.btn {
			width: 19.79vw;
			@include fontSize($font-size-20);
			border-radius: 40px;
			height: 3.13vw;
			font-weight: bold;
		}
		.reg {
			margin-top: 2.6vw;
			color: white;
		}
		.login {
			border: 3px solid white;
			margin-top: 2.08vw;
			color: $theme-color;
			background-color: white;
			border-color: $theme-color;
		}
	}
	.guide {
		z-index: 999;
		position: absolute;
		cursor: auto;
		top: 1rem;
		left: - 0.8rem;
		width: 3rem;
		padding-bottom: 20px;
		// height: 18.23vw;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, .2);
		background-color: #fff;
		display:flex;
		flex-direction: column;
		a {
			display:block;
			margin-top: 20px;
			@include fontSize($font-size-16);
			&:hover {
				color:$theme-color;
			}
		}
	}
	.contact {
		z-index: 999;
		position: absolute;
		cursor: auto;
		top: 1rem;
		left: - 1.5rem;
		width: 3rem;
		padding-bottom: 20px;
		// height: 18.23vw;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, .2);
		background-color: #fff;
		display:flex;
		flex-direction: column;
		a {
			display:block;
			margin-top: 20px;
			@include fontSize($font-size-16);
			&:hover {
				color:$theme-color;
			}
		}
	}
	.loadType {
		height: 300px;
		position: relative;
	}
	.modal-content {
		margin:20px;
		display:flex;
		flex-direction: column;
		.item {
			display:flex;
			margin:10px 0;
			@include fontSize($font-size-16);
			.label {
				width:100px;
			}
			.value {
				flex:1;
			}
		}
		a {
			color:#333;
		}
		a:hover {
			color:$theme-color;
		}
	}
	.login-info {
		width: 3.8rem;
		margin: 20px 0;
	
		padding:0 0.4rem;
		// width: 100%;
		.info{
			display:flex;
			//align-items: center;
			//justify-content:center;
		}
		.head-img {
			border-radius: 80px;
			overflow: hidden;
			height:80px;
			width: 80px;
			margin-right: 30px;
			img {
				height:80px;
				width: 80px;
			}
		}
		.user {
			@include fontSize($font-size-18);
			display: flex;
			align-items: center;
			justify-content: center;
			height:0.3rem;
			width:2rem;
			line-height: 0.3rem;
			.vipno {
				// flex:1;
			}
			.name {
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
		}
		.logout {
			width: 0.8rem;
			height:0.3rem;
			// margin-left: 20px;
			// margin-top: 10px;
			border-radius: 30px;
		}
		.selectOrder{
			margin-top: 10px;
			text-align: center;
			a{
				@include fontSize($font-size-18);
				&:hover{
					color:$theme-color;
				}
				//padding-right: 2vw;
			}
		}
	}
	
	@keyframes stretch-width {
		0% {
			width: 0;
		}
		100% {
			width: 100%;
		}
	}
	@keyframes stretch-height {
		0% {
			height: 0;
		}
		100% {
			height: auto;
		}
	}
</style>